import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBxWYQgCHccTew0XKmYecbhkOSnm_8Nqzc",
  authDomain: "clone-c8bc0.firebaseapp.com",
  databaseURL: "https://clone-c8bc0.firebaseio.com",
  projectId: "clone-c8bc0",
  storageBucket: "clone-c8bc0.appspot.com",
  messagingSenderId: "490583803239",
  appId: "1:490583803239:web:167cbe3d923e7410685bc2",
  measurementId: "G-KV91H5QCER"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
export { db, auth };